"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTargetText = getTargetText;
exports.isTargetCkeditor = isTargetCkeditor;
exports.setTargetText = setTargetText;
exports.getCurrentResponse = getCurrentResponse;
exports.onKeyboardEscape = onKeyboardEscape;
exports.onKeyboardShiftEnter = onKeyboardShiftEnter;
exports.onKeyboardEnter = onKeyboardEnter;
function getTargetText(target) {
    var _a, _b;
    if (window.CKEDITOR !== undefined) {
        const editor = (_a = CKEDITOR === null || CKEDITOR === void 0 ? void 0 : CKEDITOR.instances) === null || _a === void 0 ? void 0 : _a[target];
        if (editor) {
            return editor.getData();
        }
    }
    return ((_b = $('[name="' + target + '"]').val()) !== null && _b !== void 0 ? _b : '');
}
function isTargetCkeditor(target) {
    if (window.CKEDITOR !== undefined) {
        return !!(CKEDITOR === null || CKEDITOR === void 0 ? void 0 : CKEDITOR.instances[target]);
    }
    return false;
}
function setTargetText(target, text) {
    window.parent.postMessage({
        event: 'llm-modal-submit',
        payload: text,
    });
    if (window.CKEDITOR !== undefined) {
        const editor = CKEDITOR === null || CKEDITOR === void 0 ? void 0 : CKEDITOR.instances[target];
        if (editor) {
            editor.setData(text);
            return;
        }
    }
    const $input = $('[name="' + target + '"]');
    if ($input.length) {
        $input.val(text);
        $input.trigger('change');
    }
}
function getCurrentResponse(responses, activeResponse) {
    if (!responses.length) {
        return null;
    }
    if (activeResponse < responses.length) {
        return responses[activeResponse];
    }
    return responses === null || responses === void 0 ? void 0 : responses[responses.length - 1];
}
function onKeyboardEscape(e, callback) {
    if (e.key === 'Escape') {
        e.preventDefault();
        callback();
    }
}
function onKeyboardShiftEnter(e, callback) {
    if (e.shiftKey) {
        onKeyboardEnter(e, callback);
    }
}
function onKeyboardEnter(e, callback) {
    if (e.key === 'Enter' || e.which === 13) {
        e.preventDefault();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        callback && callback();
    }
}
